import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Error(props: IconProps): JSX.Element {
  return <Error.Outline {...props} />;
}

Error.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5925 0.325432C16.371 0.496282 18.9759 1.86308 20.8862 3.74243C23.1438 6.13433 24.3594 9.03878 24.3594 12.4558C24.3594 15.1894 23.3174 17.7521 21.5808 19.9732C19.8442 22.0234 17.413 23.561 14.6344 24.0736C11.8559 24.5861 9.07733 24.2444 6.64609 22.8776C4.21486 21.5108 2.3046 19.4606 1.26265 16.8979C0.220689 14.3351 0.0470292 11.4307 0.915327 8.86793C1.78363 6.13433 3.34656 3.91328 5.7778 2.37563C8.03537 0.837982 10.8139 0.154582 13.5925 0.325432ZM14.4608 22.3651C16.7184 21.8525 18.8023 20.6566 20.3652 18.7772C21.7545 16.8979 22.6228 14.6768 22.4491 12.2849C22.4491 9.55133 21.4072 6.81773 19.4969 4.93838C17.7603 3.22988 15.6764 2.20478 13.2452 2.03393C10.9876 1.86308 8.55635 2.37563 6.64609 3.74243C4.73584 5.10923 3.34656 6.98858 2.65192 9.38048C1.95728 11.6015 1.95728 13.9934 2.99924 16.2145C4.0412 18.4355 5.60414 20.144 7.68805 21.34C9.77197 22.5359 12.2032 22.8776 14.4608 22.3651V22.3651ZM12.3769 11.4307L16.5447 7.15943L17.7603 8.35538L13.5925 12.6266L17.7603 16.8979L16.5447 18.0938L12.3769 13.8226L8.20903 18.0938L6.99341 16.8979L11.1612 12.6266L6.99341 8.35538L8.20903 7.15943L12.3769 11.4307V11.4307Z"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
